export const CONST = {
  HEADER: $localize`End of Outbound Scan`,
  END: $localize`End`,
};
export enum ColumnIds {
  MOVEMENT = 'movement',
  DEPART_DATE = 'departDate',
  ACTIONS = 'actions',
}

export const ColumnText = {
  MOVEMENT: $localize`Movement`,
  DEPART_DATE: $localize`Depart Date`,
  ACTIONS: $localize`Actions`,
};

export const ExportColumnText = {
  MOVEMENT: $localize`Movement`,
  DEPART_DATE: $localize`Depart Date`,
};
export const EXCEL_FILE_NAME = $localize`end-outbound-scan-data`;

export interface EndOutboundScan {
  movement: string;
  departDate: string;
  sortDate: string;
}
export const MOCK_TABLE_CONSTS: EndOutboundScan[] = [
  {
    movement: 'NOTEMA1',
    departDate: 'May 08, 2023',
    sortDate: 'May 08, 2023',
  },
  {
    movement: 'NOTEMA1',
    departDate: 'May 10, 2023',
    sortDate: 'May 08, 2023',
  },
  {
    movement: 'NOTEMA2',
    departDate: 'May 02, 2023',
    sortDate: 'May 08, 2023',
  },
];
